// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".short .Bundle[data-v-7f470ae1]{height:100%;overflow-y:hidden}.short .Bundle .logo[data-v-7f470ae1]{display:none}.short .Bundle .packages[data-v-7f470ae1]{height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
